import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

const Redirect = ({ to, external }) => {
  const history = useHistory()

  useEffect(() => {
    if (external) {
      window.location = to
    } else {
      history.push(to)
    }
  }, [history, to, external])

  return null
}

export default Redirect
